/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ColumnDisplayOptionFromJSON(json) {
    return ColumnDisplayOptionFromJSONTyped(json, false);
}
export function ColumnDisplayOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'dontSort': !exists(json, 'dontSort') ? undefined : json['dontSort'],
        'columnName': !exists(json, 'columnName') ? undefined : json['columnName'],
        'direction': !exists(json, 'direction') ? undefined : json['direction'],
        'formatKind': !exists(json, 'formatKind') ? undefined : json['formatKind'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'component': !exists(json, 'component') ? undefined : json['component'],
    };
}
export function ColumnDisplayOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'displayName': value.displayName,
        'dontSort': value.dontSort,
        'columnName': value.columnName,
        'direction': value.direction,
        'formatKind': value.formatKind,
        'width': value.width,
        'component': value.component,
    };
}
